// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"gw-z","badgeLink":"hw-z","category":"iw-z","badgeLabel":"jw-z"};